import paymentPlanReview from 'shared/components/lending/paymentPlanReview/PaymentPlanReviewStrings.en';
import pdfScreen from 'shared/components/lending/PdfScreen/PdfScreenStrings.en';

export default {
  pdfScreen,
  paymentPlanReview,
};
